import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';

import orderReducer from '../../features/general/order/store/orderSlice';
import deliveryReducer from '../../features/general/delivery/store/deliverySlice';
import scheduleReducer from '../../features/general/schedule/store/scheduleSlice';
import itemReducer from '../../features/master/item/store/itemSlice';
import shipReducer from '../../features/master/ship/store/shipSlice';
import mailReducer from '../../features/master/mail/store/mailSlice';
import historyOrderReducer from '../../features/history/order/store/orderSlice';
import historyDeliveryReducer from '../../features/history/delivery/store/deliverySlice';
import historyShippingScheduleReducer from '../../features/history/shipping-schedule/store/shippingScheduleSlice';
import deliveryMessageReducer from '../../features/misc/delivery-message/store/deliveryMessageSlice';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  order: orderReducer,
  delivery: deliveryReducer,
  schedule: scheduleReducer,
  item: itemReducer,
  ship: shipReducer,
  mail: mailReducer,
  historyOrder: historyOrderReducer,
  historyDelivery: historyDeliveryReducer,
  historyShippingSchedule: historyShippingScheduleReducer,
  deliveryMessage: deliveryMessageReducer,
});

export { rootPersistConfig, rootReducer };
